import React, { useEffect, useState } from "react";

const Mon = () => {
  const [mainData, setMainData] = useState([]);
  const [serverTime, setServerTime] = useState("");

  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= 768
  );

  const serverUrl =
    window.location.hostname === "localhost" ||
    window.location.hostname === "192.168.0.254"
      ? `http://${window.location.hostname}:4000`
      : `${window.location.protocol}//smes.izenimplant.com`;

  //////////////////////////////
  // 데이터 조회
  //////////////////////////////

  const fetchData = async () => {
    try {
      const res = await fetch(
        `${serverUrl}/api/monitoring2?t=${Date.now()}`,
        {
          cache: "no-store"
        }
      );

      if (!res.ok) {
        throw new Error(`조회 실패: ${res.status}`);
      }

      const json = await res.json();

      /*
       * [
       *   [설비목록]
       * ]
       *
       * 또는
       *
       * [
       *   {설비1},
       *   {설비2}
       * ]
       *
       * 둘 다 대응
       */
      let main = [];

      if (
        Array.isArray(json) &&
        json.length > 0 &&
        Array.isArray(json[0])
      ) {
        main = json[0];
      } else if (Array.isArray(json)) {
        main = json;
      }

      /*
       * NC 번호 순으로 정렬
       */
      main = [...main].sort(
        (a, b) =>
          Number(a.MAC_NUM || 0) -
          Number(b.MAC_NUM || 0)
      );

      setMainData(main);

      if (main.length > 0) {
        setServerTime(main[0].DT || "");
      }
    } catch (error) {
      console.error(
        "모니터링 조회 오류:",
        error
      );
    }
  };

  //////////////////////////////
  // 최초 조회 + 5초 갱신
  //////////////////////////////

  useEffect(() => {
    fetchData();

    const timer = setInterval(() => {
      fetchData();
    }, 5000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  //////////////////////////////
  // 모바일 여부
  //////////////////////////////

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(
        window.innerWidth <= 768
      );
    };

    window.addEventListener(
      "resize",
      handleResize
    );

    return () => {
      window.removeEventListener(
        "resize",
        handleResize
      );
    };
  }, []);

  //////////////////////////////
  // NC1 ~ NC6 고정
  //////////////////////////////

  const machineSlots = Array.from(
    { length: 6 },
    (_, index) => {
      const macNum = index + 1;

      return (
        mainData.find(
          machine =>
            Number(machine.MAC_NUM) ===
            macNum
        ) || null
      );
    }
  );

  return (
    <div
      style={{
        ...styles.page,

        /*
         * 모바일에서는 세로 스크롤 허용
         * PC에서는 한 화면 고정
         */
        ...(isMobile
          ? styles.pageMobile
          : {})
      }}
    >
      {/* HEADER */}

      <div
        style={{
          ...styles.header,

          ...(isMobile
            ? styles.headerMobile
            : {})
        }}
      >
        <div
          style={{
            ...styles.title,

            ...(isMobile
              ? styles.titleMobile
              : {})
          }}
        >
          MACHINE MONITORING
        </div>

        <div
          style={{
            ...styles.headerRight,

            ...(isMobile
              ? styles.headerRightMobile
              : {})
          }}
        >
          <div
            style={{
              ...styles.clock,

              ...(isMobile
                ? styles.clockMobile
                : {})
            }}
          >
            {format(serverTime)}
          </div>
        </div>
      </div>

      {/* NC1 ~ NC6 */}

      <div
        style={
          isMobile
            ? styles.machineListMobile
            : styles.machineGrid
        }
      >
        {machineSlots.map(
          (machine, index) =>
            machine ? (
              <Card
                key={`machine-${index + 1}`}
                m={machine}
                isMobile={isMobile}
              />
            ) : (
              <EmptyCard
                key={`empty-${index + 1}`}
                macNum={index + 1}
                isMobile={isMobile}
              />
            )
        )}
      </div>
    </div>
  );
};

//////////////////////////////
// Card
//////////////////////////////

function Card({
  m,
  isMobile
}) {
  const color = getColor(m.STATE);

  return (
    <div
      style={{
        ...styles.card,

        ...(isMobile
          ? styles.cardMobile
          : {}),

        borderColor: color
      }}
    >
      {/* 상태 */}

      <div
        style={{
          ...styles.state,
          background: color
        }}
      >
        {m.STATE || "-"}
      </div>

      {/* NC 번호 */}

      <div style={styles.mc}>
        NC{m.MAC_NUM}
      </div>

      <Row
        label="설비"
        value={m.BMA_NAME || "-"}
      />

      <Row
        label="O NUMBER"
        value={
          m.PROGRAM_NUMBER || "-"
        }
      />

      <Row
        label="TOOL NUMBER"
        value={
          m.TOOL_NUMBER || "-"
        }
      />

      <Row
        label="치식 / 거래처 / 환자"
        value={`${m.PPI_DENTALNUM || "-"} / ${
          m.BCU_NAME || "-"
        } / ${
          m.PPI_PATIENTNAME || "-"
        }`}
      />

      <Row
        label="COUNT"
        value={Number(
          m.PART_COUNT || 0
        ).toLocaleString()}
      />

      <Row
        label="TIME"
        value={
          format(m.G_DATETIME)
        }
      />
    </div>
  );
}

//////////////////////////////
// 빈 설비 카드
//////////////////////////////

function EmptyCard({
  macNum,
  isMobile
}) {
  return (
    <div
      style={{
        ...styles.emptyCard,

        ...(isMobile
          ? styles.cardMobile
          : {})
      }}
    >
      <div style={styles.emptyMc}>
        NC{macNum}
      </div>

      <div style={styles.emptyText}>
        NO MACHINE
      </div>
    </div>
  );
}

//////////////////////////////
// Row
//////////////////////////////

function Row({
  label,
  value
}) {
  return (
    <div style={styles.infoRow}>
      <div style={styles.label}>
        {label}
      </div>

      <div style={styles.value}>
        {value}
      </div>
    </div>
  );
}

//////////////////////////////
// 날짜
//////////////////////////////

function format(t) {
  if (!t) return "";

  return String(t)
    .replace("T", " ")
    .replace("Z", "")
    .split(".")[0];
}

//////////////////////////////
// 상태 색상
//////////////////////////////

function getColor(state) {
  switch (state) {
    case "EMERGENCY":
      return "#ff1744";

    case "ALARM":
      return "#ff5252";

    case "EDIT":
      return "#ffd600";

    case "RUNNING":
      return "#00e676";

    case "IDLE":
      return "#40c4ff";

    case "SETUP":
      return "#ff9100";

    case "POWER_ON":
      return "#9e9e9e";

    default:
      return "#555";
  }
}

//////////////////////////////
// STYLE
// 전부 이 컴포넌트 내부 inline style
//////////////////////////////

const styles = {
  //////////////////////////////
  // 전체 화면 - PC
  //////////////////////////////

  page: {
    width: "100%",
    height: "100vh",

    background: "#0b0f14",
    color: "#fff",

    padding: 20,

    boxSizing: "border-box",

    fontFamily: "Pretendard",

    display: "flex",
    flexDirection: "column",

    overflow: "hidden"
  },

  //////////////////////////////
  // 전체 화면 - 모바일
  //////////////////////////////

  pageMobile: {
    height: "auto",

    minHeight: "100vh",

    padding: 12,

    overflow: "visible"
  },

  //////////////////////////////
  // HEADER
  //////////////////////////////

  header: {
    position: "relative",

    height: 48,
    minHeight: 48,

    marginBottom: 20,

    flexShrink: 0
  },

  headerMobile: {
    height: "auto",

    minHeight: 70
  },

  title: {
    textAlign: "center",

    fontSize: 26,

    fontWeight: 800,

    lineHeight: "48px"
  },

  titleMobile: {
    fontSize: 20,

    lineHeight: "32px"
  },

  headerRight: {
    position: "absolute",

    right: 0,
    top: 0,

    height: 48,

    display: "flex",

    alignItems: "center"
  },

  headerRightMobile: {
    position: "relative",

    right: "auto",
    top: "auto",

    height: "auto",

    marginTop: 4,

    justifyContent: "flex-end"
  },

  clock: {
    fontSize: 18,

    fontWeight: 600,

    whiteSpace: "nowrap"
  },

  clockMobile: {
    fontSize: 14
  },

  //////////////////////////////
  // PC
  //
  // NC1 NC2 NC3
  // NC4 NC5 NC6
  //////////////////////////////

  machineGrid: {
    flex: 1,

    minWidth: 0,
    minHeight: 0,

    display: "grid",

    gridTemplateColumns:
      "repeat(3, minmax(0, 1fr))",

    gridTemplateRows:
      "repeat(2, minmax(0, 1fr))",

    gap: 18,

    overflow: "hidden"
  },

  //////////////////////////////
  // 모바일
  //////////////////////////////

  machineListMobile: {
    display: "flex",

    flexDirection: "column",

    gap: 18
  },

  //////////////////////////////
  // 설비 카드
  //////////////////////////////

  card: {
    position: "relative",

    width: "100%",
    height: "100%",

    minWidth: 0,
    minHeight: 0,

    background: "#121821",

    borderRadius: 16,

    border: "4px solid",

    padding: "16px 22px",

    boxSizing: "border-box",

    overflow: "hidden"
  },

  //////////////////////////////
  // 모바일 카드
  //////////////////////////////

  cardMobile: {
    height: "auto",

    minHeight: 320
  },

  //////////////////////////////
  // 빈 설비
  //////////////////////////////

  emptyCard: {
    position: "relative",

    width: "100%",
    height: "100%",

    minWidth: 0,
    minHeight: 0,

    background: "#121821",

    borderRadius: 16,

    border:
      "4px solid #252c35",

    padding: "16px 22px",

    boxSizing: "border-box",

    display: "flex",

    alignItems: "center",

    justifyContent: "center",

    overflow: "hidden"
  },

  emptyMc: {
    position: "absolute",

    top: 16,

    left: 22,

    color: "#555",

    fontSize: 26,

    fontWeight: 800
  },

  emptyText: {
    color: "#555",

    fontSize: 22,

    fontWeight: 800
  },

  //////////////////////////////
  // 상태
  //////////////////////////////

  state: {
    position: "absolute",

    top: 14,

    right: 14,

    padding: "6px 14px",

    borderRadius: 8,

    fontWeight: 700,

    fontSize: 12,

    color: "#000"
  },

  //////////////////////////////
  // NC 번호
  //////////////////////////////

  mc: {
    fontSize: 26,

    fontWeight: 800,

    marginBottom: 12
  },

  //////////////////////////////
  // 데이터
  //////////////////////////////

  infoRow: {
    marginTop: 7
  },

  label: {
    fontSize: 12,

    lineHeight: "16px",

    color: "#9aa3ad"
  },

  value: {
    marginTop: 1,

    fontSize: 18,

    lineHeight: "23px",

    fontWeight: 700,

    whiteSpace: "nowrap",

    overflow: "hidden",

    textOverflow: "ellipsis"
  }
};

export default Mon;